// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__134cx","header":"Messages_header__2T1nI"};